import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from "styled-components";

export const Content = styled.div`
  background: url('/assets/fundo_trees.jpg');
  background-size: 100% 100%; 
  background-repeat: no-repeat;
  height: 90vh;
  width: 100%;
  padding-top: auto;
  margin-top: 45px;

  @media (max-width: 1919px) {
    height: 120vh;
  }

  @media (max-width: 1365px) {
    height: 105vh;
    background-size: 100% 100%; 
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Header = styled.div`
  padding: 40px 0 8px 98px;

  @media (max-width: 1365px) {
    padding: 20px 10px;
  }
`;

export const SliderBox = styled.div`
  max-width: 1365px;
  margin: 20px auto 0 auto;

  .slick-dots {
    bottom: -50px;
    
    button:not(.slick-active)::before {
      color: #fff;
      opacity: 1;
    }

    .slick-active button::before {
      color: #FF5227;
    }
  }

  @media (max-width: 1023px) {
    position: relative;
    max-width: 360px;
  }

  @media (min-width: 1024px) and (max-width: 1365px) {
    position: relative;
    max-width: 70%;
  }
`;

export const MobileOverlay = styled.div`
  position: absolute;
  top: 50%;
  width: 100%;
  height: calc(100% - 16px);
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.7);
`;

export const Title = styled.h1`
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 1.75rem;
  line-height: 33px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 0;

  @media (max-width: 1365px) {
    font-weight: 700;
    font-size: 20px;
    line-height: 23.7px;
  }
`;

export const SubjectsList = styled.ul`
  padding-left: 20px;
  list-style-type: none;
  text-align: center;
  width: max-content;
  margin: 20px auto;
  display: flex;
  text-align: left;

  @media (max-width: 1365px) {
    padding-left: 40px;
    list-style-type: disc;
    flex-direction: column;
    margin: 20px 30%;
  }
`;

export const SubjectItem = styled.li`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 22px;
  color: #051a45;
  margin-right: 10px;
  border-right: 2px solid #FF5227;
  padding-right: 10px;
  
  :last-child {
    margin-right: 0;
    border-right: none;
  }

  @media (max-width: 1365px) {
    font-size: 0.875rem;
    line-height: 19px;
    margin-right: 0;
    border-right: none;
    padding-right: 0;
  }
`;

export const SliderArrow = styled.div`
  position: absolute;
  width: 16px;
  top: 44%;
  right: 34px;
  opacity: 1;
  z-index: 9;
  cursor: pointer;
  fill: #FF5227;

  &.hide {
    display: none;
  }

  ${(props) =>
    props.isPrev &&
    `
      left: 34px;

      > svg {
        transform: rotate(180deg);
      }
    `};

  @media (max-width: 1365px) {
    right: 8px;

    ${(props) =>
      props.isPrev &&
      `
      left: 8px;
    `};
  }
`;
